let activeUnsavedMessage: string | null = null;

export const registerUnsavedChanges = (message: string): (() => void) => {
  activeUnsavedMessage = message;
  return () => {
    if (activeUnsavedMessage === message) activeUnsavedMessage = null;
  };
};

export const confirmUnsavedNavigation = (): boolean =>
  !activeUnsavedMessage || window.confirm(activeUnsavedMessage);
